/**
 * GoogleTagManager
 *
 * Injects the GTM <script> snippet into <head> and the <noscript> iframe
 * immediately after <body> open — production builds only (VITE_APP_ENV=production
 * or the Vite built-in `import.meta.env.PROD` flag).
 *
 * Nothing is injected in development or staging builds.
 */
import { useEffect } from 'react'

const GTM_ID = 'GTM-T6F49W3N'

export default function GoogleTagManager() {
  // import.meta.env.PROD is `true` only when Vite builds with mode=production.
  // Staging deploys to `main` use mode=staging (or default), so they stay clean.
  if (!import.meta.env.PROD) return null

  useEffect(() => {
    // ── Head script ──────────────────────────────────────────────────────────
    // Guard against double-injection (e.g. HMR or StrictMode double-effects).
    if (!document.getElementById('gtm-script')) {
      const script = document.createElement('script')
      script.id = 'gtm-script'
      script.async = true
      script.innerHTML = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`
      // Insert as the first child of <head> so it fires before other tags.
      document.head.insertBefore(script, document.head.firstChild)
    }

    // ── Body noscript ─────────────────────────────────────────────────────────
    if (!document.getElementById('gtm-noscript')) {
      const noscript = document.createElement('noscript')
      noscript.id = 'gtm-noscript'
      const iframe = document.createElement('iframe')
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
      iframe.height = '0'
      iframe.width = '0'
      iframe.style.cssText = 'display:none;visibility:hidden'
      noscript.appendChild(iframe)
      // Insert as the first child of <body>.
      document.body.insertBefore(noscript, document.body.firstChild)
    }
  }, [])

  return null
}
